import { getLogger, Logger } from 'ia-react-core';
import OmniLogging from './OmniLogging';

export function getOmniLogger(namespace: string): Logger {
  return getLogger(
    { namespace, reporters: [(ns: string, level: string, ...args) => OmniLogging.log(ns, level, ...args)] },
  );
}
